import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {invoiceReducerToken, reducerInvoiceProvider} from './store/reducers/custom-invoices.reducer';
import {StoreModule} from '@ngrx/store';
import {INVOICES_FEATURE} from './store/selectors/custom-invoice.selector';
import {CustomInvoiceHistoryModule} from './custom-invoice-history/custom-invoice-history.module';
import {EffectsModule} from '@ngrx/effects';
import {CustomInvoicesHistoryEffects} from './custom-invoice-history/store/effects/custom-invoices-history.effects';
import {CustomInvoicesDocumentTypesEffects} from './custom-invoice-history/store/effects/custom-invoices-document-types.effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    CustomInvoiceHistoryModule,
    StoreModule.forFeature(INVOICES_FEATURE, invoiceReducerToken),
    EffectsModule.forFeature([
      CustomInvoicesHistoryEffects,
      CustomInvoicesDocumentTypesEffects
    ]),
  ],
  providers: [
    reducerInvoiceProvider,
  ]
})
export class CustomInvoicesModule {
}

